import { Icon, IconProps } from "./Icon";

export function IconWasher(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M20.63 0H3.34A1.36 1.36 0 0 0 2 1.36v21.28A1.36 1.36 0 0 0 3.34 24h17.29A1.35 1.35 0 0 0 22 22.64V1.36A1.35 1.35 0 0 0 20.63 0ZM3.34 1h17.29a.36.36 0 0 1 .35.36V5H3V1.36A.36.36 0 0 1 3.34 1Zm17.29 22H3.34a.36.36 0 0 1-.34-.36V6h18v16.64a.36.36 0 0 1-.37.36ZM19 2a1 1 0 1 0 0 2 1 1 0 1 0 0-2zM5 3h5.02v1H5zm7 6a6 6 0 0 0-6 6 6.18 6.18 0 0 0 .39 2.12A6 6 0 1 0 12 9Zm0 1a5 5 0 0 1 4.94 4.36 4.57 4.57 0 0 0-4.9.9 5.56 5.56 0 0 1-2.68 1.69 2.9 2.9 0 0 1-2.1-.43A5.1 5.1 0 0 1 7 15a5 5 0 0 1 5-5Zm0 10a5 5 0 0 1-4.09-2.13 3.9 3.9 0 0 0 1 .14 3.36 3.36 0 0 0 .71-.08 6.49 6.49 0 0 0 3.16-2 3.67 3.67 0 0 1 4.23-.53A5 5 0 0 1 12 20Z" />
    </Icon>
  );
}
